<template>
  <div class="btn-select-wash-vial">
    <Tippy
      :isInteractive="true"
      trigger="click"
      placement="bottom-start"
      :duration="[200, 67]"
      :isDisabled="isDisabled"
      :popperOptions="popperOptions"
    >
      <template #trigger>
        <Btn height="s" icon-left="gradient" :disabled="isDisabled" data-test-id="btn-wash-needle">
          <slot>Wash needle</slot>
        </Btn>
      </template>
      <template #default="{ hide, isShow }">
        <GlobalEvents v-if="isShow" @keydown.esc="hide" />
        <WashVialSelector
          class="btn-select-wash-vial__selector"
          @select="selectVial($event, hide)"
        />
      </template>
    </Tippy>
  </div>
</template>

<script>
  import Btn from '@/uikitBase/btns/Btn';
  import Tippy from '@/uikitBase/popups/vueTippy/Tippy';
  import WashVialSelector from '../private/WashVialSelector';
  import { props, EVENT_SELECT } from '../shared/config.ts';

  export default {
    name: 'DesktopBtnSelectWashVial',

    components: {
      Btn,
      Tippy,
      WashVialSelector,
    },

    props,

    computed: {
      popperOptions() {
        return {
          modifiers: {
            preventOverflow: {
              boundariesElement: 'window',
              enabled: true,
            },
          },
        };
      },
    },

    methods: {
      selectVial(vial, hide) {
        this.$emit(EVENT_SELECT, vial);
        hide();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btn-select-wash-vial {
    &__selector {
      width: max-content;
    }
  }
</style>
